// src/api/smtpSettings.ts
import api from "./api";

export interface SmtpSettings {
  id: string;
  host: string;
  port: number;
  username: string;
  sender_name: string | null;
  from_email: string | null;
  use_tls: boolean;
  is_active: boolean;
  // GET never returns the password — this only says whether one is stored.
  has_password: boolean;
  updated_at: string | null;
}

export interface SmtpSettingsDefaults {
  host: string;
  port: number;
}

export interface SmtpSettingsGetResponse {
  settings: SmtpSettings | null;
  defaults: SmtpSettingsDefaults;
}

export interface SmtpSettingsPayload {
  host?: string;
  port?: number;
  username?: string;
  // Omit to keep the currently stored password unchanged.
  password?: string;
  sender_name?: string;
  from_email?: string;
  use_tls?: boolean;
}

export const smtpSettingsApi = {
  get: () => api.get<SmtpSettingsGetResponse>(`/smtp-settings`),
  save: (payload: SmtpSettingsPayload) => api.post(`/smtp-settings`, payload),
};
